/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_MethodInputs */

const vi_payment_method = /** @type {(inputs: Payment_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương thức thanh toán`)
};

/**

* @param {Payment_MethodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_method = /** @type {((inputs?: Payment_MethodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_MethodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_method(inputs)
});